import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const AntdDateCellRenderer = ({ value }) => {
  // AG Grid date filter and editor use YYYY-MM-DD format.
  const dateValue = value ? moment(value, 'YYYY-MM-DD') : null;

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <DatePicker
        value={dateValue}
        style={{ width: '100%' }}
        open={false}
        bordered={false}
        allowClear={false}
      />
    </div>
  );
};

export default AntdDateCellRenderer;
